module.exports = __webpack_public_path__ + "static/media/correios-color.fb7b6772.png";